export const missingImageUrls = [
  'https://imagedelivery.net/LfHarEEHw85fo7v7-lUDxQ/d5aea059-fbb4-4c8b-894d-eefa4d32d700/list',
];
